import {
  GET_LIST_CUSTOMER,
  GET_LIST_CUSTOMER_SUCCESS,
  GET_LIST_CUSTOMER_FAILURE,
  GET_DETAIL_CUSTOMER,
  GET_DETAIL_CUSTOMER_SUCCESS,
  GET_DETAIL_CUSTOMER_FAILURE,
  LICH_SU_GIAO_DICH_CUSTOMER,
  LICH_SU_GIAO_DICH_CUSTOMER_SUCCESS,
  LICH_SU_GIAO_DICH_CUSTOMER_FAILURE,
  GET_AUTOCOMPLETE_CUSTOMER,
  GET_AUTOCOMPLETE_CUSTOMER_SUCCESS,
  GET_AUTOCOMPLETE_CUSTOMER_FAILURE,
} from "./actionTypes";

export const getListCustomer = (dataSearch) => ({
  type: GET_LIST_CUSTOMER,
});

export const getListCustomerSuccess = (data) => ({
  type: GET_LIST_CUSTOMER_SUCCESS,
  payload: data,
});

export const getListCustomerFailure = () => ({
  type: GET_LIST_CUSTOMER_FAILURE,
});

export const getAutocompleteCustomer = (dataSearch) => ({
  type: GET_AUTOCOMPLETE_CUSTOMER,
  dataSearch,
});

export const getAutocompleteCustomerSuccess = (data) => ({
  type: GET_AUTOCOMPLETE_CUSTOMER_SUCCESS,
  payload: data,
});

export const getAutocompleteCustomerFailure = () => ({
  type: GET_AUTOCOMPLETE_CUSTOMER_FAILURE,
});

export const getDetailCustomer = (dataSearch) => ({
  type: GET_DETAIL_CUSTOMER,
  dataSearch,
});

export const getDetailCustomerSuccess = (data) => ({
  type: GET_DETAIL_CUSTOMER_SUCCESS,
  payload: data,
});

export const getDetailCustomerFailure = () => ({
  type: GET_DETAIL_CUSTOMER_FAILURE,
});

export const lichSuGiaoDich = (dataSearch) => ({
  type: LICH_SU_GIAO_DICH_CUSTOMER,
  dataSearch,
});

export const lichSuGiaoDichSuccess = (data) => ({
  type: LICH_SU_GIAO_DICH_CUSTOMER_SUCCESS,
  payload: data,
});

export const lichSuGiaoDichFailure = () => ({
  type: LICH_SU_GIAO_DICH_CUSTOMER_FAILURE,
});
